module.exports = __webpack_public_path__ + "img/pjykpt.03f8e4d5.png";